import { render, staticRenderFns } from "./MantenedorLocalidadBase.vue?vue&type=template&id=fc75eff8&"
import script from "./MantenedorLocalidadBase.vue?vue&type=script&lang=ts&"
export * from "./MantenedorLocalidadBase.vue?vue&type=script&lang=ts&"
import style0 from "./MantenedorLocalidadBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports